module.exports = __webpack_public_path__ + "static/img/consult.94b55a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operation-bar/consult.png
// module id = 6mz3
// module chunks = 21